import { Box } from "@chakra-ui/react";
import TableEmployeeDevice from "./tableEmployeeDevice";
import TableDeviceChangeRequest from "./tableDeviceChangeRequest";
import TableCheckinRegistration from "./tableCheckinRegistration";
import TableCheckinRegistrationRequest from "./tableCheckinRegistrationRequest";
import TableCheckinRegistrationHistory from "./tableCheckinRegistrationHistory";
import { useTab } from "../../contexts/useTab";

export default function DeviceManager() {
  const { activityTab } = useTab();

  const tabs = [
    { title: "Thiết bị đăng nhập", content: <TableEmployeeDevice /> },
    { title: "Yêu cầu đổi thiết bị", content: <TableDeviceChangeRequest /> },
    // Chấm công luồng mới - Bước 1
    { title: "Đăng ký chấm công", content: <TableCheckinRegistration /> },
    {
      title: "Đơn đổi thiết bị chấm công",
      content: <TableCheckinRegistrationRequest />,
    },
    {
      title: "Lịch sử thiết bị chấm công",
      content: <TableCheckinRegistrationHistory />,
    },
  ];

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      {tabs[activityTab]?.content}
    </Box>
  );
}
